import { Injectable, OnDestroy } from '@angular/core';
import { LockService } from '@lbmx/root-services';
import { AppSetting } from '@lbmx/types';
import { BehaviorSubject, Subject } from 'rxjs';
import { ConfigProvider } from 'src/app/provider/config-provider';

export interface LoginAsConfig {
  username: string;
  userKey: number;
}

@Injectable()
export class LoginAsService implements OnDestroy {
  private _shouldDestroy = new Subject();
  private showLoginAsModalBehaviorSubject = new BehaviorSubject<LoginAsConfig>(
    null
  );
  public showLoginAsModal = this.showLoginAsModalBehaviorSubject.asObservable();
  public appSettings: AppSetting = this.configPrv.AppSetting;

  constructor(
    private configPrv: ConfigProvider,
    private lockService: LockService
  ) {}

  public loginAs(config: LoginAsConfig) {
    this.lockService
      .acquire('switchMarketplace')
      ?.then(() => {
        this.showLoginAsModalBehaviorSubject.next(config);
      })
      .release();
  }

  public ngOnDestroy(): void {
    this._shouldDestroy.next(true);
  }
}
